import React, { useEffect, useState } from "react";

const UPGRADE_EMAIL =
  "mailto:info@foodcostincloud.it?subject=Attivazione%20piano%20completo%20Norma";

export function TrialPopupModal({ popup, onClose }) {
  if (!popup) return null;
  const isWide = popup.key === "free_session";
  const continueTrial = popup.key === "trial_like";
  const contactUpgrade = () => { window.location.href = UPGRADE_EMAIL; };

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-slate-950/60 p-3 backdrop-blur-sm sm:p-6"
      role="dialog"
      aria-modal="true"
      aria-label="Informazioni sul piano Norma"
      onMouseDown={(event) => { if (event.target === event.currentTarget) onClose?.(); }}
    >
      <div className={`relative w-full overflow-hidden rounded-2xl bg-white shadow-2xl ${isWide ? "max-w-5xl" : "max-w-xl"}`}>
        <img
          src={popup.image_url}
          alt="Informazioni sulla prova e sui piani Norma"
          className="block h-auto max-h-[92vh] w-full object-contain"
        />
        <button
          type="button"
          aria-label="Chiudi"
          title="Chiudi"
          className="absolute right-[1.5%] top-[1.5%] h-[9%] w-[9%] rounded-full focus:outline-none focus:ring-2 focus:ring-blue-600"
          onClick={onClose}
        />
        <button
          type="button"
          aria-label="Scopri i piani Norma"
          className={`absolute rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-600 ${isWide ? "bottom-[10%] left-[44%] h-[10%] w-[25%]" : "bottom-[1.5%] left-[2.5%] h-[11%] w-[46%]"}`}
          onClick={contactUpgrade}
        />
        <button
          type="button"
          aria-label={continueTrial ? "Continua la prova" : "Attiva il piano completo"}
          className={`absolute rounded-xl focus:outline-none focus:ring-2 focus:ring-emerald-600 ${isWide ? "bottom-[10%] right-[4%] h-[10%] w-[26%]" : "bottom-[1.5%] right-[2.5%] h-[11%] w-[46%]"}`}
          onClick={continueTrial ? onClose : contactUpgrade}
        />
      </div>
    </div>
  );
}

export default function TrialPopupManager({ enabled }) {
  const [queue, setQueue] = useState([]);
  const current = queue[0] || null;

  useEffect(() => {
    if (!enabled) {
      setQueue([]);
      return undefined;
    }
    let alive = true;
    fetch("/api/trial-popups/status.php", { credentials: "include" })
      .then((response) => response.json().catch(() => null))
      .then((data) => { if (alive) setQueue(Array.isArray(data?.popups) ? data.popups : []); })
      .catch(() => { if (alive) setQueue([]); });
    return () => { alive = false; };
  }, [enabled]);

  useEffect(() => {
    if (!current?.key || !current?.occurrence_key) return;
    fetch("/api/trial-popups/seen.php", {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ popup_key: current.key, occurrence_key: current.occurrence_key }),
    }).catch(() => {});
  }, [current?.key, current?.occurrence_key]);

  if (!enabled || !current) return null;
  return <TrialPopupModal popup={current} onClose={() => setQueue((items) => items.slice(1))} />;
}
